import { TrackingPageModel } from '../tracking-page.model';
import {
  getAsset,
  getFontConfig,
  getSocialIcons,
  getFooterItems,
  getLogo,
  getLanguageMenu,
  white,
  getProductItems
} from './helpers';

export const carparts: TrackingPageModel = {
  languageMenu: getLanguageMenu('Roboto Condensed', '#191d28ff'),
  searchPageInput: {
    backgroundColor: '#ffffff',
    borderColor: '#ced4da',
    borderRadius: 0,
    borderWidth: 1,
    shadow: 'none',
    ...getFontConfig('Ubuntu', '#6d788c')
  },
  searchPageTitle: {
    fontSize: 25,
    ...getFontConfig('Roboto Condensed', '#1a1e29ff', '700')
  },
  background: {
    color: white,
    useBackgroundImage: true,
    imageUrl: getAsset('/images/themes/car-parts.png'),
    backgroundMode: 'cover',
    backgroundPosition: 'top',
    backgroundRepeat: 'no-repeat'
  },
  card: {
    backgroundColor: '#ffffff',
    linksColor: '#b91d00ff',
    linksUnderline: false,
    headerBackground: '#ffffff',
    footerBackground: '#ffffff',
    borderColor: '#d5d9e1',
    borderRadius: 0,
    borderWidth: 0,
    shadow: 'none',
    trackingNumberField: 'trackingNumber',
    ...getFontConfig('Roboto Condensed', '#1a1e29ff', '700')
  },
  orderCard: {
    backgroundColor: '#f0f0f035',
    linksColor: '#5780ff',
    linksUnderline: false,
    headerBackground: '#ffffff',
    footerBackground: '#ffffff',
    borderColor: '#ffffffff',
    borderRadius: 0,
    borderWidth: 1,
    shadow: 'none',
    ...getFontConfig('Ubuntu', '#2E4068')
  },
  orderNumber: {
    alignment: 'center',
    fontSize: 18,
    ...getFontConfig('Roboto Condensed', '#f5341dff', '700italic')
  },
  orderStatus: {
    alignment: 'center',
    fontSize: 20,
    ...getFontConfig('Roboto Condensed', '#1a1e29ff', '700')
  },
  orderLastUpdated: {
    alignment: 'center',
    fontSize: 15,
    ...getFontConfig('Roboto Condensed', '#565656ff')
  },
  notYetShippedItemsTitle: {
    alignment: 'center',
    fontSize: 15,
    ...getFontConfig('Roboto Mono', '#f5341dff')
  },
  orderStatusOn: true,
  orderNumberOn: true,
  orderLastUpdatedOn: true,
  orderItemsFrame: {
    on: true,
    scroll: false,
    itemsLimit: 1,
    borderColor: '#f0f0f0ff',
    borderWidth: 1,
    borderRadius: 0,
    backgroundColor: '#ffffffff',
    shadow: 'none',
    button: {
      on: true,
      backgroundColor: '#21232bff',
      borderColor: '#2E4068',
      borderRadius: 0,
      borderWidth: 0,
      shadow: 'none',
      ...getFontConfig('Roboto Condensed', '#ffffffff', '700')
    },
    itemCard: {
      backgroundColor: '#ffffffff',
      borderColor: '#2E4068',
      borderRadius: 0,
      borderWidth: 0,
      shadow: 'none',
      title: {
        alignment: 'left',
        fontSize: 16,
        ...getFontConfig('Roboto Condensed', '#1a1e29ff', '700')
      },
      info: {
        alignment: 'left',
        fontSize: 14,
        ...getFontConfig('Roboto Condensed', '#727272ff')
      },
      showAttributes: false
    }
  },
  searchButton: {
    on: true,
    backgroundColor: '#991010ff',
    borderColor: '#2e406800',
    borderRadius: 0,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Roboto Condensed', '#ffffffff', '700')
  },
  detailsButton: {
    backgroundColor: '#940c00ff',
    borderColor: '#5780ff',
    borderRadius: 0,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Roboto Condensed', white, '700')
  },
  trackButton: {
    backgroundColor: '#9e1d00ff',
    borderColor: '#ee7227',
    borderRadius: 0,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Roboto Condensed', white, '700')
  },
  pageScroll: {
    scrollColor: '#2E4068',
    borderRadius: 2,
    backgroundColor: '#ffffff00'
  },
  scripts: {
    head: null,
    body: null
  },
  logo: getLogo(getAsset('/images/themes/car-parts-logo.png')),
  socialIcons: getSocialIcons('#362727ff', true),
  sidebar: {
    parcelIcon: 'icon-parcel',
    groupIcon: 'icon-track_number',
    backgroundColor: '#ffffff',
    borderColor: '#CED2DC',
    borderRadius: 0,
    borderWidth: 0,
    shadow: 'none',
    sidebarField: null,
    ...getFontConfig('Roboto Condensed', '#1f1f1fff', '700')
  },
  footer: {
    backgroundColor: '#444444ab',
    linksColor: '#ffffffff',
    linksUnderline: false,
    ...getFontConfig('Roboto Condensed', '#ffffffff'),
    ...getFooterItems()
  },
  header: {
    backgroundColor: '#ffffffa5'
  },
  faviconUrl: '/assets/favicon/favicon-32x32.png',
  sidebarProductsFeed: {
    on: false,
    backgroundColor: '#ffffff9f',
    borderColor: '#d5d9e1',
    borderRadius: 0,
    borderWidth: 0,
    shadow: 'none',
    card: {
      backgroundColor: '#ffffffff',
      borderColor: '#ffffff',
      borderRadius: 0,
      borderWidth: 5,
      shadow: 'none',
      button: {
        backgroundColor: '#9b0901ff',
        borderColor: '#5780ff',
        borderRadius: 0,
        borderWidth: 0,
        shadow: 'none',
        ...getFontConfig('Roboto Condensed', white, '700')
      },
      buttonText: 'BUY NOW',
      title: {
        alignment: 'left',
        fontSize: 20,
        ...getFontConfig('Roboto Condensed', '#1a1e29ff', '700')
      },
      regularPrice: {
        alignment: 'left',
        fontSize: 10,
        ...getFontConfig('Roboto Condensed', '#828282')
      },
      discountedPrice: {
        alignment: 'center',
        fontSize: 15,
        ...getFontConfig('Roboto Condensed', '#bc2200ff', '700italic')
      },
      imageBorderRadius: 0,
      imageHeight: 120,
      imageWidth: 120
    },
    feedUrl: '',
    productItems: getProductItems('car-parts'),
    sliderOptions: {
      autoplay: true,
      autoplayDelay: 3000,
      loop: true,
      arrowColor: '#f52e1dff',
      arrowSize: 35
    }
  },
  mainProductsFeed: {
    on: true,
    backgroundColor: '#ffffff9f',
    borderColor: '#d5d9e1',
    borderRadius: 0,
    borderWidth: 0,
    shadow: 'none',
    card: {
      backgroundColor: '#ffffffff',
      borderColor: '#ffffff',
      borderRadius: 0,
      borderWidth: 5,
      shadow: 'none',
      button: {
        backgroundColor: '#9b0901ff',
        borderColor: '#5780ff',
        borderRadius: 0,
        borderWidth: 0,
        shadow: 'none',
        ...getFontConfig('Roboto Condensed', white, '700')
      },
      buttonText: 'BUY NOW',
      title: {
        alignment: 'left',
        fontSize: 20,
        ...getFontConfig('Roboto Condensed', '#1a1e29ff', '700')
      },
      regularPrice: {
        alignment: 'left',
        fontSize: 10,
        ...getFontConfig('Roboto Condensed', '#828282')
      },
      discountedPrice: {
        alignment: 'center',
        fontSize: 15,
        ...getFontConfig('Roboto Condensed', '#bc2200ff', '700italic')
      },
      imageBorderRadius: 0,
      imageHeight: 120,
      imageWidth: 120
    },
    feedUrl: '',
    productItems: getProductItems('car-parts'),
    sliderOptions: {
      autoplay: true,
      autoplayDelay: 3000,
      loop: true,
      arrowColor: '#f52e1dff',
      arrowSize: 35
    }
  },
  seoTitle: ''
};
